import React from 'react';
import Modal from '@/components/Modal';
import Button from '@/components/Button';

interface UnableToDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  bodyText: string;
  buttonText: string;
}

/**
 * Shown in place of the delete confirm dialog/generic delete-error banner when deletion turns out
 * not to be possible right now - either the daily delete-block window check at click time
 * (WITHIN_BLOCK_WINDOW - see openDeleteDialog in useScheduledPaymentAction, checked for both
 * kinds) or, batch-only, a 4213/4903 conflict from the group delete endpoint itself
 * (DELETE_CONFLICT - see confirmDelete/isDeletionBlockedError) - an individual scheduled payment's
 * delete (DeactivateScheduledBankPaymentUseCaseImpl on the backend) has no equivalent state/window
 * check, so it never returns this. Copy is passed in since it differs both by reason and by
 * payment kind - see ScheduledPaymentModal/BatchOverviewModal, which each render their own
 * title/body/button for
 * `unableToDeleteReason`. Dismissing just closes this - unlike AlreadyActionedModal, it doesn't
 * also close the payment/batch detail view, since there's nothing stale to navigate away from.
 */
const UnableToDeleteModal: React.FC<UnableToDeleteModalProps> = ({
  isOpen,
  onClose,
  headerText,
  bodyText,
  buttonText
}) => (
  <Modal isOpen={isOpen} onClose={onClose} headerText={headerText} headerVariant="xxl-medium">
    <div className="flex flex-col gap-y-6 py-4">
      <p className="text-sm font-medium text-emerge-navy">{bodyText}</p>

      <div className="flex justify-center">
        <Button size="pill" className="w-[140px]" onClick={onClose}>
          {buttonText}
        </Button>
      </div>
    </div>
  </Modal>
);

export default UnableToDeleteModal;
